module.exports = __webpack_public_path__ + "img/seal-question.675b4273.svg";